module.exports = __webpack_public_path__ + "img/m_ico.e0ddb7d6.svg";